import { Navigate, useParams } from '@tanstack/react-router';

/**
 * Legacy deep-link shim. The receipt detail used to be a slide-over on its own
 * child route; it now opens inline on the list page, keyed by the `receiptId`
 * search param. This path only survives so existing links and bookmarks keep
 * landing on the right receipt.
 */
export function CashReceiptDetailRoute() {
  const { receiptId } = useParams({
    from: '/authenticated/accounts-receivable/cash-receipts/$receiptId',
  });

  return (
    <Navigate
      to="/accounts-receivable/cash-receipts"
      search={{ receiptId }}
      replace
    />
  );
}
